import object1 from "./1.png";

export const waterWipesAntibacterial1 = [
  object1,
  object1,
  object1,
  object1,
  object1,
];
